module.exports = __webpack_public_path__ + "static/media/tournaments-future-menu-icon.ca42e0dd.svg";